import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../../reducers";
import { Combo2Service } from "../../../../services/index";
import { SalesInvoiceService } from "../../../../services/salesinvoice.service";
import { SalesOrderService } from "../../../../services/salesOrder.service";

import { PrintData } from "../../../master/print/print";
declare var google;

@Component({
  selector: "salesInvoice",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./counterTransfer.html",
})
export class counterTransfer implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    fin_year: "",
    party_id: "",
    party: "",
    shirt_designno: "",
    dc_no: "",
    dcid: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  invList = [];
  printData;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("invoiceTemplate") invoiceTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("convertWTemplate") convertWTemplate: TemplateRef<any>;
  @ViewChild("verifyTemplate") verifyTemplate: TemplateRef<any>;
  @ViewChild("convertRTemplate") convertRTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("splTemplate") splTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finAuto") finAuto;
  @ViewChild("partyAuto") partyAuto;

  finCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  print: boolean = false;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  invoiceList: any = [];
  totpcs: any;
  inv_no: "";
  dcid: "";

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private salesinvservice: SalesInvoiceService,
    private salesservice: SalesOrderService

  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();

    this.getPartyList();
    // this.getInvoiceCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Dc No",
        prop: "dc_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Dc Date",
        prop: "inv_date_formatted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "From Counter",
        prop: "from_party",
        headerClass: "text-center",
        cellClass: "text-left",
        minWidth: 310,
        maxWidth: 310,
        width: 310,
      },
      {
        name: "To Counter",
        prop: "to_party",
        headerClass: "text-center",
        cellClass: "text-left",
        minWidth: 310,
        maxWidth: 310,
        width: 310,
      },
      {
        name: "F.Tot",
        prop: "fspcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "H.Tot",
        prop: "hspcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Total Pcs",
        prop: "invpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 100,
      },
      // {name: 'No of Designs',prop: 'no_of_design',headerClass:'text-center',cellClass: 'text-center', minWidth: 80,maxWidth: 80,width: 80 },
      {
        name: "Action",
        prop: "sno",
        minWidth: 130,
        maxWidth: 130,
        cellClass: "text-center",
        width: 130,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      // {
      //   name: "Details",
      //   prop: "sno",
      //   minWidth: 60,
      //   maxWidth: 60,
      //   width: 60,
      //   cellClass: "text-center",
      //   sortable: false,
      //   cellTemplate: this.detailsTemplate,
      // },
      // {
      //   name: "Invoice",
      //   prop: "sno",
      //   minWidth: 60,
      //   maxWidth: 60,
      //   width: 60,
      //   cellClass: "text-center",
      //   sortable: false,
      //   cellTemplate: this.invoiceTemplate,
      // },
      // {
      //   name: "Verify",
      //   prop: "sno",
      //   minWidth: 60,
      //   maxWidth: 60,
      //   width: 60,
      //   cellClass: "text-center",
      //   sortable: false,
      //   cellTemplate: this.verifyTemplate,
      // },
    ];
    // if(this.menu.sale_type == "estimate"){
    //     let obj = { name: 'Convert-Wholesale', prop: 'sno', minWidth: 80, maxWidth: 80, width: 80, cellClass: 'text-center',sortable: false, cellTemplate: this.convertWTemplate },
    //     obj1 = { name: 'Convert-Retail', prop: 'sno', minWidth: 80, maxWidth: 80, width: 80, cellClass: 'text-center',sortable: false, cellTemplate: this.convertRTemplate };
    //     this.columns.push(obj);
    //     this.columns.push(obj1);
    // }

    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
    a.removeClass("mat-autocomplete-visible");
    setTimeout(function () {
      $("#finyear").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getcounterTransfer();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  verify(row) {
    this.inv_no = row.invoiceno;
    this.dcid = row.dcid;
  }

  clearFilter(): void {
    this.filter.party = "";
    this.filter.party_id = "";
    this.filter.dcid = "";
    this.filter.shirt_designno = "";
    this.filter.dc_no = "";
    this.applyFilter();
  }

  closeModal() {
    var verifiedby1 = document.getElementById("verifiedby") as HTMLInputElement;
    this.inv_no = "";
    this.dcid = "";
    verifiedby1.value = "";
  }
  saveModal() {
    var verifytemp = document.getElementById("verifiedby") as HTMLInputElement;
    var verifiedby = verifytemp.value;
    let params = {
      dcid: this.dcid,
      verifiedby: verifiedby,
    };
    let that = this;
    this.salesinvservice.saveEstimateVerify(params).then(function (res: any) {
      if (res.message == "Access Denied") {
        swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
        return false
      }
      that.getcounterTransfer();
      this.dcid = "";
      this.inv_no = "";
    });

    this.dcid = "";
    this.inv_no = "";
    verifytemp.value = "";
  }

  applyFilter(): void {
    this.filterPanel.close();
    if (this.filter.dc_no == "") {
      this.filter.dcid = "";
    }
    if (this.filter.party == "") {
      this.filter.party_id = "";
    }
    this.getcounterTransfer();
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getcounterTransfer();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};


    // if (mode == "Add" && this.menu.sale_type == 'specialEstimate') {

    //   console.log("check", this.menu.sale_type)
    //   tabObj = {
    //     action: "NewTab",
    //     params: {
    //       //  tabParent: 'Transaction',
    //       tabName: "ADD SALES INVOICE",
    //       title: "ADD SALES INVOICE",
    //       tabParent: "MASTER",
    //       mode: mode,
    //       data: row,
    //       name: "ADD SALES INVOICE",
    //       sale_type: this.menu.sale_type,
    //     },
    //   };
    // }
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD COUNTER TRANSFER",
          title: "ADD COUNTER TRANSFER",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "ADD COUNTER TRANSFER",
          sale_type: this.menu.sale_type,
        },
      };
    }
    
    else if (mode == "View") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "VIEW COUNTER TRANSFER",
          title: "VIEW COUNTER TRANSFER",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "VIEW COUNTER TRANSFER",
          sale_type: this.menu.sale_type,
        },
      };
    }
    else if (mode == "Inwarded") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "VIEW COUNTER TRANSFER",
          title: "VIEW COUNTER TRANSFER",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "VIEW COUNTER TRANSFER",
          sale_type: this.menu.sale_type,
        },
      };
    }



    this.tabUpdateEvent.emit(tabObj);
  }
  getcounterTransfer(): void {
    let params: any = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      sales_type: this.menu.sale_type,
      inward_type: this.menu.param,
      fin_year: this.filter.fin_year,
      party_name: this.filter.party,
      invoiceno: this.filter.dc_no,
      shirt_designno: this.filter.shirt_designno,
    };

    params.type = "NOT VERIFIED";
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesservice
      .getcounterTransfer(params)
      .then(function (res: any) {

        if (res.message == "Access Denied") {
          swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
          let tabObj = {
            action: "CloseTab",
            params: {},
          };
          setTimeout(() => {
            that.tabUpdateEvent.emit(tabObj);
          }, 2000);
        }

        that.loadingIndicator = false;
        that.page.count = res.total;
        that.invoiceList = res.data;
        that.calcTotal();
      });
  }
  calcTotal() {
    for (let i = 0; i < this.invoiceList.length; i++) {
      this.invoiceList[i].totpcs =
        parseInt(this.invoiceList[i].ftotpcs) +
        parseInt(this.invoiceList[i].htotpcs);
      this.invoiceList[i].inv_date_formatted = this.datePipe.transform(
        this.invoiceList[i].dcdt,
        "dd-MM-yyyy"
      );
    }
  }

  bsModalRef: BsModalRef;
  printInvoice(row) {
    let params = {
      printType: "invoice",
      party_id: row.party_id,
      dcid: row.dcid,
    };
    this.salesinvservice.salesInvoicePrint(params).then((res: any) => {
      this.printData = res;

      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printcontent = this.printData;
    });
  }
  viewInvoice(row) {
    let params = {
      printType: "details",
      party_id: row.party_id,
      dcid: row.dcid,
    };
    this.salesinvservice.salesInvoicePrint(params).then((res: any) => {
      // let var = "<div>aaaa</div>"
      this.printData = res;
      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printdet = this.printData;
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      //   that.finyearCtrl.setValue(res.data[0].fin_id);
      //       that.filter.finYrVal = res.data[0].finyear;
      //   that.filter.fin_year = res.data[0].finyear;
    });
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      this.filter.fin_year = fitem["finyear"];
      return fitem["finyear"];
    }
    return "";
  }

  getPartyList() {
    this.salesinvservice.getSalesParty({}).then((res: any) => {
      this.partyList = res;
    });
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { name: id });
      this.filter.party_id = fitem["genLedid"];
      return fitem["name"];
    }
    return "";
  }
  getInvoiceCombo(name) {
    let partylist = _.filter(this.partyList, { name: name });
    this.filter.party_id = partylist[0]["genLedid"];
    this.filter.dc_no = "";
    let params = {
      genLedid: partylist[0]["genLedid"],
      page: 1,
      start: 0,
      limit: 100,
    };
    this.salesinvservice.getInvoiceCombo(params).then((res: any) => {
      this.invList = res;
    });
  }
  onClickInvoice(dc_no) {
    let invlist = _.filter(this.invList, { invoiceno: dc_no });
    this.filter.dcid = invlist[0].dcid;
  }
  convertToWhole(row) {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getcounterTransfer();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ADD SALES INVOICE",
        title: "CONVERT TO WHOLESALE",
        tabParent: "MASTER",
        data: row,
        mode: "Convert",
        name: "CONVERT TO WHOLESALE",
        sale_type: this.menu.sale_type,
        to_sale_type: "wholesale",
        tabTitle: "CONVERT TO WHOLESALE",
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
  convertToRetail(row) {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getcounterTransfer();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    tabObj = {
      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ADD SALES INVOICE",
        title: "CONVERT TO RETAIL",
        tabParent: "MASTER",
        data: row,
        mode: "Convert",
        name: "CONVERT TO RETAIL",
        sale_type: this.menu.sale_type,
        tabTitle: "CONVERT TO RETAIL",
        to_sale_type: "retail",
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
  convertTospecial(row) {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getcounterTransfer();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    tabObj = {

      action: "NewTab",
      params: {
        //  tabParent: 'Transaction',
        tabName: "ADD SPECIAL SALES INVOICE",
        title: "ADD SPECIAL SALES INVOICE",
        tabParent: "MASTER",
        mode: 'Convert',
        data: row,
        name: "ADD SPECIAL SALES INVOICE",
        sale_type: this.menu.sale_type,
        to_sale_type: "specialinvoice",
      },
    };
    this.tabUpdateEvent.emit(tabObj);
  }
  deleteInvoice(row) {
    let that = this;
    row.tabevent = undefined;
    let params = {
      dcid: row.dcid,
      so_no: row.so_no,
      party_id: row.party_id,
    };
    console.log(row);
    swal({
      title: "Are you sure to delete this Invoice Details?",
      text: "You will not be able to recover this Invoice",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.salesinvservice
          .delete(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getcounterTransfer();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) { }
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/designSoReport/counterTransfer.ts